import React, { createContext, ReactNode, useContext } from 'react';

import { RootStore } from './RootStore';

const rootStore = new RootStore();

const StoreContext = createContext<RootStore>({} as RootStore);

export const StoreProvider = (props: { children: ReactNode }) => {
  return <StoreContext.Provider value={rootStore}>{props.children}</StoreContext.Provider>;
};

export const useStore = () => useContext(StoreContext);
